import React, { useMemo } from 'react';
import { DeliveryHistoryFilter, PartnerOption, StatusOption } from '../types/deliveryHistory.types';
import DateRangePicker from '@/shared/components/forms/DateRangePicker';
import SearchableSelect, { SelectOption } from '@/shared/components/forms/SearchableSelect';

interface DeliveryFilterSectionProps {
    filter: DeliveryHistoryFilter;
    userType: string | null;
    partners: PartnerOption[];
    partnersLoading: boolean;
    statusCodes: StatusOption[];
    statusLoading: boolean;
    onFilterChange: (newFilter: Partial<DeliveryHistoryFilter>) => void;
    onSearch: () => void;
    onReset: () => void;
}

const DeliveryFilterSection: React.FC<DeliveryFilterSectionProps> = ({
                                                                         filter,
                                                                         userType,
                                                                         partners,
                                                                         partnersLoading,
                                                                         statusCodes,
                                                                         statusLoading,
                                                                         onFilterChange,
                                                                         onSearch,
                                                                         onReset,
                                                                     }) => {
    const partnerOptions: SelectOption[] = useMemo(() => {
        if (!partners || partners.length === 0) return [];
        return partners.map((partner) => ({
            value: partner.suppId,
            label: partner.suppName || partner.suppId,
        }));
    }, [partners]);

    const statusOptions: SelectOption[] = useMemo(() => {
        if (!statusCodes || statusCodes.length === 0) return [];
        return statusCodes.map((status) => ({
            value: status.code,
            label: status.name,
        }));
    }, [statusCodes]);

    return (
        <div className="card search-card">
            <div className="card-body">
                <div className={`search-form ${userType === 'HEADQUARTERS' ? '' : 'supplier-view'}`}>
                    <div className="form-group date-range-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-calendar-alt" />
                                조회 기간
                            </label>
                            <DateRangePicker
                                startDate={filter.startDate}
                                endDate={filter.endDate}
                                onStartDateChange={(value) => onFilterChange({ startDate: value })}
                                onEndDateChange={(value) => onFilterChange({ endDate: value })}
                                startLabel="시작일"
                                endLabel="종료일"
                            />
                        </div>
                    </div>

                    {userType === 'HEADQUARTERS' && (
                        <div className="form-group">
                            <div className="form-field">
                                <label className="form-label">
                                    <i className="fas fa-building" />
                                    협력사
                                </label>
                                <SearchableSelect
                                    options={partnerOptions}
                                    value={filter.partnerId}
                                    onChange={(value) => onFilterChange({ partnerId: value })}
                                    placeholder="협력사 검색..."
                                    disabled={partnersLoading}
                                    showAllOption={true}
                                    allOptionLabel="전체"
                                />
                            </div>
                        </div>
                    )}

                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-flag" />
                                상태
                            </label>
                            <SearchableSelect
                                options={statusOptions}
                                value={filter.status}
                                onChange={(value) => onFilterChange({ status: value })}
                                placeholder="상태 선택..."
                                disabled={statusLoading}
                                showAllOption={true}
                                allOptionLabel="전체"
                            />
                        </div>
                    </div>

                    <div className="form-group button-group">
                        <button className="btn btn-secondary" onClick={onReset}>
                            <i className="fas fa-redo" />
                            초기화
                        </button>
                        <button className="btn btn-primary" onClick={onSearch}>
                            <i className="fas fa-search" />
                            검색
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeliveryFilterSection;
